import "./src/styles/docs.min.css"
import "@coreui/coreui-pro/scss/coreui.scss";
import "highlight.js/styles/agate.css"
import '@babel/polyfill';

// eslint-disable-next-line import/prefer-default-export
export const onClientEntry = () => {
  // Without this function body the import will not be picked up.
}